export { formatHorizon } from './model/automation';
export { aiTransformationRoute } from './route';
export { strategyKeys } from './strategy/api/query-keys';
export { useStrategySummary } from './strategy/api/use-strategy-summary';
export { EmployeeCell, ManagerCell, TransformationLeadCell } from './strategy/components/ListPeopleCells';
export { StrategyShare } from './strategy/components/StrategyShare';
export { isAiTransformationStrategyReleased } from './strategy/strategy-release';
export type { AiTransformationItemTilePayload } from './url-tile';
export {
    AI_TRANSFORMATION_ITEM_TILE_SLOT_KEY,
    AI_TRANSFORMATION_ITEM_TILE_TYPE,
    aiTransformationItemUrlTileDefinition,
    aiTransformationUrlTileModule,
    createAiTransformationItemTilePayload,
} from './url-tile';

export const loadAiTransformationPage = async () => {
    const { AiTransformationEntryPage } = await import('./AiTransformationEntryPage');

    return { Component: AiTransformationEntryPage };
};
